<template>
  <div id="recipient-setting">
    <div
      v-if="!readOnly"
      class="header"
    >
      {{ label ?? 'Send notifications to' }}
    </div>
    <div
      v-if="!readOnly"
      class="add-email-input"
    >
      <input
        :class="['input', isValidEmail() ? '' : '']"
        placeholder="Enter Email"
        :value="email"
        @keyup.enter="addEmail"
        @input="onChange('email', $event.target.value)"
      >
      <button
        :class="['add-button align-center', isValidEmail() ? '' : 'disabled']"
        :disabled="!isValidEmail()"
        @click="addEmail"
      >
        Add
        <span class="icon-Plus sac__font-18 f-white ml-2 mt-2" />
      </button>
    </div>
    <div
      v-if="!readOnly && errorObj.emailErr"
      class="error-text"
    >
      {{ errorObj.emailErr }}
    </div>
    <div
      v-if="recipients.length"
      class="recipient-table mt-6"
    >
      <div class="table-list">
        <div
          v-for="(e, idx) in recipients"
          :key="idx"
          class="email-row"
        >
          <div class="mr-2">{{ e }}</div>
          <v-icon
            v-if="adminRole === 'admin' && !readOnly"
            color="white"
            dark
            medium
            @click="removeNotificationEmails(idx)"
          >
            mdi-close-circle-outline
          </v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import emailValidation from '@shared/lib/errorCatch/emailValidation';

export default {
  name: 'RecipientSetting',
  props: {
    recipients: Array,
    readOnly: Boolean,
    email: String,
    label: String,
    addEmail: Function,
    removeEmail: Function,
    onChange: Function,
    errorObj: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters([
      'adminRole',
    ]),
  },
  methods: {
    isValidEmail() {
      if (this.email) {
        return emailValidation(this.email) && !this.recipients.includes(this.email);
      }
      return false;
    },
    removeNotificationEmails(idx) {
      const emailsCopy = _.cloneDeep(this.recipients);
      this.removeEmail(emailsCopy[idx]);
      emailsCopy.splice(idx, 1);
      return emailsCopy;
    },
  },
};
</script>

<style lang="scss" scoped>

#recipient-setting {
  .header {
    font-size: 1rem;
    font-weight: 500;
    color: $N80;
  }
  .add-email-input {
    display: flex;
    .input {
      flex: 1;
      padding: 0 10px;
      background-color: $NBLUE5;
      height: 40px;
      border-radius: 4px;
      margin-top: 10px;
    }
    .email-invalid {
      background-color: $TOMATO25;
    }
    .add-button {
      margin-top: 10px;
      background-color: $NBLUE90;
      height: 40px;
      padding: 0 24px;
      margin-left: 8px;
      border-radius: 4px;
      color: $WHITE;
      font-size: 1.125rem;
      font-weight: 500;
      &.disabled {
        background-color: $N10;
        &:hover {
          opacity: 1;
        }
      }
    }
  }
  .recipient-table {
    .table-header {
      display: grid;
      width: 100%;
      grid-template-columns: auto 1fr 1fr;
      justify-content: flex-start;
      align-items: center;
      gap: 1rem;
      padding: 8px 10px;
      font-weight: 600;
      background-color: $NBLUE10;
      color: $N100;
    }
    .table-list {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      .email-row {
        display: flex;
        margin: 5px;
        background-color: $PRIMARY;
        flex-direction: row;
        color: $WHITE;

        align-items: center;
        justify-content: space-between;
        padding: 8px 12px;
        font-size: 1rem;
        font-weight: 500;
        border-radius: 50px;
      }
    }
  }
}

</style>
